const WOW_LOGO = "https://res.cloudinary.com/dpsxh6ywz/image/upload/v1761996315/ADAMJEE_LOGO_cqtm0h.png"
const layout_details = {
    JPA: {
        is_collaborator: false,
        collaborator_logo: ''
    },
    WOW: {
        is_collaborator: true,
        collaborator_logo: WOW_LOGO
        // collaborator_logo:'https://res.cloudinary.com/dpsxh6ywz/image/upload/v1692342879/wow-logo-2_kvlmdw.png'
    }
}

const OnlineTrainingConstant = {
    key: "Online Training",
    label: "Online Training"
}

const check_layout_handle = (instituteCode) => {
    console.log({ instituteCode });

    let return_data

    if (instituteCode === 'Jawan Pakistan Academy' || instituteCode === OnlineTrainingConstant.key) {

        return_data = layout_details.JPA

    }

    else {
        return_data = layout_details.WOW
    }

    return return_data



    // return layout_details[instituteCode === undefined ? 'WOW' : instituteCode] 


}

export { layout_details, check_layout_handle, OnlineTrainingConstant }